import { navLinks, footerPartners } from '@/mocks/homeData';

export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-950 text-foreground-300">
      <div className="mx-auto px-4 md:px-6 max-w-[1200px] py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <a
              href="#hero"
              onClick={(e) => { e.preventDefault(); scrollTo('#hero'); }}
              className="inline-flex items-center gap-2 mb-4"
            >
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-line text-base text-white"></i>
              </span>
              <span className="text-lg font-bold text-white">
                911<span className="text-primary-400">黑料网</span>
              </span>
            </a>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4 max-w-xs">
              911黑料网是国内领先的娱乐爆料聚合平台，致力于为全网吃瓜群众提供最新、最全、最有深度的黑料资讯。独家爆料、深度追踪、安全匿名投稿——你关心的猛料，尽在911黑料网。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-md bg-foreground-800 hover:bg-primary-500 text-foreground-300 hover:text-white transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-md bg-foreground-800 hover:bg-primary-500 text-foreground-300 hover:text-white transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-md bg-foreground-800 hover:bg-primary-500 text-foreground-300 hover:text-white transition-colors cursor-pointer">
                <i className="ri-tiktok-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-4">快速导航</h4>
            <nav className="flex flex-col gap-2.5">
              <a href="#hero" onClick={(e) => { e.preventDefault(); scrollTo('#hero'); }} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">首页</a>
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => { e.preventDefault(); scrollTo(link.href); }}
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-4">内容分类</h4>
            <nav className="flex flex-col gap-2.5">
              <a href="#cards" onClick={(e) => { e.preventDefault(); scrollTo('#cards'); }} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">精选猛料</a>
              <a href="#updates" onClick={(e) => { e.preventDefault(); scrollTo('#updates'); }} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">实时快讯</a>
              <a href="#media" onClick={(e) => { e.preventDefault(); scrollTo('#media'); }} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">独家影像</a>
              <a href="#carousel" onClick={(e) => { e.preventDefault(); scrollTo('#carousel'); }} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">焦点专题</a>
              <a href="#faq" onClick={(e) => { e.preventDefault(); scrollTo('#faq'); }} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">常见问题</a>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-4">合作伙伴</h4>
            <div className="grid grid-cols-2 gap-2">
              {footerPartners.map((partner, idx) => (
                <div
                  key={idx}
                  className="px-3 py-2 rounded-md bg-foreground-800 text-center"
                >
                  <span className="text-xs text-foreground-500">{partner}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 md:mt-12 pt-6 border-t border-foreground-800/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; 2020 - 2026 911黑料网 版权所有 | 本站内容仅供娱乐参考
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-500">
              <a href="#hero" className="hover:text-primary-400 transition-colors cursor-pointer">用户协议</a>
              <a href="#hero" className="hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
              <a href="#hero" className="hover:text-primary-400 transition-colors cursor-pointer">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}